export default __webpack_public_path__ + "static/media/Anti-histaminefr.3b70fa39.jpg";